module.exports = __webpack_public_path__ + "img/HotspotTriage.be442b2e.png";